export default defineNuxtPlugin(() => {
  if (typeof window === "undefined") return;

  // await 하지 않는다. 플러그인이 끝나야 라우터 초기 내비게이션(= 전역 미들웨어)이
  // 시작되는데, ensurePk 는 브릿지 대기(최대 3초)와 pk.js 다운로드를 한다.
  // 여기서는 미리 깨워두기만 하고, 실제 사용처인 useNativeBridge 가 호출 시점에 await 한다.
  ensurePk().catch((error) => {
    console.warn("pk 준비 실패:", error);
  });
});
